import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError, from } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "../endpoints/auth.service";
import { catchError, mergeMap, map } from "rxjs/operators";
import { Router } from "@angular/router";
import { ToastService } from "./toast.service";

@Injectable({
	providedIn: "root",
})
export class AuthInterceptorService {
	constructor(
		private authService: AuthService,
		private router: Router,
		private toast: ToastService
	) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const token: string = AuthService.getAuthToken();

		let request = req;

		if (req.url.includes(environment.api.url) && token) {
			if (
				AuthService.isTimeToRefresh() &&
				!req.url.includes(environment.api.refresh) &&
				!req.url.includes(environment.api.logout)
			) {
				return from(
					new Promise<void>((resolve) => {
						this.authService.refresh().subscribe({
							next: () => resolve(),
							error: () => resolve(),
						});
					})
				).pipe(
					mergeMap(() => {
						request = req.clone({
							setHeaders: {
								authorization: `Bearer ${token}`,
							},
						});
						return next.handle(request);
					})
				);
			} else {
				request = req.clone({
					setHeaders: {
						authorization: `Bearer ${token}`,
					},
				});
			}
		}

		return next.handle(request).pipe(
			catchError((err: HttpErrorResponse) => {
				let message1 = 'Aviso';
				let message2 = 'No tiene permitido acceder aquí';

				if (err && err.error && err.error.status_message){
					let status_message = err.error.status_message;
					if (status_message == 'unauthorized'){
						message1 = 'Problemas al iniciar sesión';
						message2 = 'No tienes permitido acceder al sistema';
					}
					if (status_message == 'blocked'){
						message1 = 'Usuario bloqueado';
						message2 = 'Contacte con el administrador';
					}
					if (status_message == 'expired_password'){
						message1 = 'Contraseña expirada';
						message2 = 'Intente nuevamente iniciar sesión';
					}
					if (status_message == 'invalid_credentials'){
						message1 = 'Acceso incorrecto';
						message2 = 'Ingrese nuevamente su email y contraseña';
					}
				}
				if (err.status === 401) {
					this.router.navigateByUrl("/login");
					return from(
						Promise.all([message1, message2])
					).pipe(
						mergeMap(([message1, message2]) => {
							this.toast.show(message1, message2, "warn");
							sessionStorage.clear();
							return throwError(err);
						})
					);
				}

				return throwError(err);
			})
		);
	}
}
